import React, { useEffect, useState } from "react";
import { Card } from 'primereact/card';
import FullscreenLayout from "@/Themes/Default/Layouts/FullscreenLayout";
import ResetPasswordForm from "@/Components/Forms/ResetPasswordForm";
import { useParams } from "react-router-dom";

/**
 * Reset password page
 */
const ResetPasswordPage = () => {
    let { code } = useParams('code');

    useEffect(() => {
        document.title = 'Reset password' + ' · ' + document.title;        
    }, []);

    return (
        <FullscreenLayout>
            <Card>
                <ResetPasswordForm code={code} />
            </Card>
        </FullscreenLayout>
    );
};

export default ResetPasswordPage;